import React, { FC, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Infos from '../../components/infos/infos';
import SubmitButton from '../../components/submit-button/submit-button';

// Helpers
import {
  backofficeRecipientsToEngagementRows,
  deleteActivity,
  dueOnToDate,
  filesToAttachmentDisplay,
} from '../../helpers/activity-helper';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerBiggerSide,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Providers
import { GeneralContext } from '../../providers/general-provider';

// Services
import ActivityService from '../../services/activity-service';

const ActivityFollow: FC<{
  activity: BackofficeActivityDetailDto;
  activityService: ActivityService;
}> = ({ activity, activityService }) => {
  const navigate = useNavigate();
  const { activityId } = useParams<{ activityId: string }>();
  const { setModalContent, setToastContent } = useContext(GeneralContext);

  const activityData: (
    | InfosData
    | InfosDataAttachments
    | ActivityDataAttachments
  )[] = [
      {
        type: 'title',
        content: activity.title,
      },
      {
        type: 'activityInfo',
        description: activity.description,
        dueDate: dueOnToDate(activity.dueOn),
      },
      {
        type: 'attachments',
        content: filesToAttachmentDisplay(activity.files),
      },
    ];

  const engagementData: InfosDataList = {
    type: 'list',
    content: {
      titles: [
        {
          text: 'Aluno',
        },
        {
          text: 'Turma',
        },
        {
          text: 'Responsável',
        },
        {
          text: 'Visualizados',
          customStyle: { textAlign: 'center' },
        },
        {
          text: 'Concluídos',
          customStyle: { textAlign: 'center' },
        },
      ],
      rows: backofficeRecipientsToEngagementRows(activity.recipients),
    },
  };

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.doubleWithActionButtons}
      withoutShadowBox={true}
      biggerSide={BaseContentContainerBiggerSide.right}
      actionButtonPosition={BaseContentContainerActionButtonPosition.bottom}
    >
      <Infos
        title='atividade enviada'
        titleColor='intermediate'
        data={activityData}
      />
      <Infos
        title='engajamento'
        titleColor='curiosity'
        backgroundColor='gray'
        data={engagementData}
      />
      <ButtonsBar pattern='firstSeparate' verticalAlign='bottom'>
        <Link to='/atividades/listar'>
          <SubmitButton value='cancelar' variant='terciary' />
        </Link>
        <SubmitButton
          value='deletar'
          variant='terciary'
          onClick={() =>
            deleteActivity(
              activityService,
              activityId,
              setModalContent,
              setToastContent,
              navigate
            )
          }
        />
      </ButtonsBar>
    </BaseContentContainer>
  );
};

export default ActivityFollow;
